import {PricingChangeType} from "@/shared/timrTypes";
import {FeatureModule} from "@/shared/timr";
import {FeatureModuleSelectionBase, FeatureModuleSelectionDialogConfig} from "./featureModuleSelectionBase";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import * as Input from "@/shared/utils/input";

const template = `
			<div id="featureModuleSelectionDialog">
				<div id="baseFeatureModules">
				</div>
				<h4 id="extensionFeatureModulesHeader" style="display:none">${messages["pricing.selectionDialog.extensionModules"]}</h4>
				<div id="extensionFeatureModules" class="feature-module-grid-view">
				</div>
			</div>
			`;

/**
 * Custom web component that draws the content of the feature module selection dialog.
 */
export class FeatureModuleSelectionDialog extends FeatureModuleSelectionBase {

	protected callback: (selectedModules: FeatureModule[], pricePerUser: number) => void;
	protected modal: BootstrapModal.Modal;

	public static show(config: FeatureModuleSelectionDialogConfig, callback: (selectedModules: FeatureModule[], pricePerUser: number) => void): void {
		const dialog = document.createElement("feature-module-selection-dialog") as FeatureModuleSelectionDialog;
		dialog.config = config;
		dialog.callback = callback;
		dialog.show();
	}

	protected connectedCallback() {
		this.innerHTML = template;
		this.buildFeatureModuleItems(this.config);
		this.onFeatureModuleSelected();
	}

	protected show(): void {
		this.modal = new BootstrapModal.Modal({
			title: "",
			message: $(this),
			size: "modal-xl",
			destroyOnClose: true,
			closeButton: false,
			css: {
				content: "pt-10 scrollable-modal"
			},
			buttons: [
				{
					text: "dialog.cancel",
					css: "cancelButton btn-default"
				},
				{
					text: "dialog.applySelection",
					css: "saveButton btn-primary",
					action: (m) => {
						m.close();	// close the modal first to avoid double clicks if the buttons get reset
						this.callback(this.getSelectedModules(), this.getNewPrice());
					}
				}
			]
		});
		this.modal.show();
	}

	protected buildMonthlyYearlySwitch() {
		const header = this.modal.getDomModal().find(".modal-header");
		header.addClass("pb-10")
			.children()
			.wrapAll(`<div></div>`)
			.parent()
			.wrapAll(`<div class="display-flex justify-content-space-between flex-valign-middle"></div>`)
			.parent()
			.append(`
						<div class="display-flex flex-valign-middle">
							<h4 class="m-0">${messages["pricing.selectionDialog.paymentPeriod"]}</h4>
							<div class="ml-15 btn-group">
								<button id="priceMonthlyButton" class="btn btn-default">${messages["pricing.selectionDialog.paymentPeriod.MONTHLY"]}</button>
								<button id="priceYearlyButton" class="btn btn-primary">${messages["pricing.selectionDialog.paymentPeriod.ANNUALLY"]}</button>
							</div>
						</div>
				`);

		header.find(".modal-title").append(`
				<div class="display-flex flex-valign-middle">
					<h4 class="m-0">${messages.withArguments("pricing.selectionDialog.userCount", this.config.userCount)}</h4>
				</div>
			`);

		this.initMonthlyYearlySwitch("#priceMonthlyButton", "#priceYearlyButton");
	}

	protected buildModalFooter() {
		const footer = this.modal.getDomModal().find(".modal-footer");
		footer.addClass("p-20 pt-10")
			.children()
			.wrapAll(`<div class="text-nowrap"></div>`)
			.parent()
			.wrapAll(`<div class="display-flex justify-content-space-between"></div>`)
			.parent()
			.prepend(`<div id="totalPrice" class="flex-row ml-0 mt-5"></div>`);
		footer.prepend(`<div data-error class="flex-row editable-error"></div>`);
	}

	protected toggleSaveButton(selectedModules: FeatureModule[]): void {
		const error = $("[data-error]");
		const hasSelectedModules = selectedModules.length > 0;
		if (this.getNewPrice() > this.config.oldPrice) {
			const enableButton = this.config.allowedChange !== PricingChangeType.DOWNGRADE && hasSelectedModules;
			Input.toggle(document.querySelector(".saveButton"), enableButton);
			error.text(enableButton ? "" : messages["pricing.customize.noUpgradeAndDowngrade.upgrade"]);
		} else if (this.getNewPrice() < this.config.oldPrice) {
			const enableButton = this.config.allowedChange !== PricingChangeType.UPGRADE && hasSelectedModules;
			Input.toggle(document.querySelector(".saveButton"), enableButton);
			error.text(enableButton ? "" : messages["pricing.customize.noUpgradeAndDowngrade.downgrade"]);
		} else {
			Input.toggle(document.querySelector(".saveButton"), hasSelectedModules);
			error.text("");
		}
	}

	protected getNewPrice() {
		return this.pricePerUser + this.basePrice;
	}
}

